import { ProjectOverviewBase } from "@/components/ui/project-overview";
import {
  IElementsSubscriptionsFeatures,
  Mode,
  SceneFilterLookAtInitialState,
} from "@/modes/mode";
import { selectAllCadModels } from "@/store/cad/cad-selectors";
import {
  selectCanReadCAD,
  selectCanReadPointCloud,
} from "@/store/subscription-features/subscription-features-selectors";
import { isIElementValidPointCloudStream } from "@/types/type-guards";
import { selectChildDepthFirst } from "@faro-lotv/app-component-toolbox";
import { IElement, isIElementGaussianSplats } from "@faro-lotv/ielement-types";
import { FlyOverviewScene } from "../flywalk-mode/fly-overview-scene";
import { OverviewOverlay } from "./overview-overlay";
import { OVERVIEW_MODE_INITIAL_STATE } from "./overview-state";
import { OverviewTransition } from "./overview-transition";

export const overviewMode: Mode<SceneFilterLookAtInitialState> = {
  name: "overview",
  initialState: OVERVIEW_MODE_INITIAL_STATE,
  hasCustomCanvasStyle: true,
  ModeScene: FlyOverviewScene,
  ModeTransition: OverviewTransition,
  ModeOverlay: OverviewOverlay,
  ModePanel: ProjectOverviewBase,
  canBeStartedWith: canOverviewBeStartedWith,
};

function canOverviewBeStartedWith(
  activeElement: IElement,
  { iElements, subscriptionFeatures }: IElementsSubscriptionsFeatures,
): boolean {
  if (
    selectCanReadCAD({ subscriptionFeatures }) &&
    selectAllCadModels({ iElements }).length
  ) {
    return true;
  }

  if (
    selectChildDepthFirst(
      activeElement,
      isIElementGaussianSplats,
    )({ iElements })
  ) {
    return true;
  }

  return (
    selectCanReadPointCloud({ subscriptionFeatures }) &&
    !!selectChildDepthFirst(
      activeElement,
      isIElementValidPointCloudStream,
    )({ iElements })
  );
}
